import { Layout } from "antd";
import { usePageTitle } from "hooks";
import React from "react";
import AccessDenied from "./AccessDenied";
export const Unauthorized: React.FC<{
  isAccessFromPage?: boolean;
}> = ({ isAccessFromPage }) => {
  usePageTitle("HTTP 401 Unauthorized");
  const contain = () => {
    return (
      <Layout className="mainInnerLayout" style={{ height: "100%" }}>
        <h3>HTTP 401 Unauthorized</h3>
        <AccessDenied isAccessFromPage={isAccessFromPage} />
      </Layout>
    );
  };

  if (isAccessFromPage) {
    return <React.Fragment>{contain()}</React.Fragment>;
  } else {
    return contain();
  }
};
